import normalize from '../util/normalize';

import accountsReducer, { DEFAULT_ACCOUNTS_STATE } from './account/reducer';
import adminUsersReducer, { DEFAULT_ADMIN_USERS_STATE } from './user/reducer';
import catalogsReducer, { DEFAULT_CATALOGS_STATE } from './catalogs/reducer';
import catalogTypesReducer, { DEFAULT_CATALOG_TYPES_STATE } from './catalogTypes/reducer';
import productContractGroupsReducer, { DEFAULT_PRODUCT_CONTRACT_GROUPS_STATE } from './productContracts/reducer';
import departmentsReducer, { DEFAULT_DEPARTMENTS_STATE } from './departments/reducer';

import { setHeaderIsOpen } from './actions';

export const DEFAULT_ADMIN_STATE = {
  accounts: DEFAULT_ACCOUNTS_STATE,
  adminUsers: DEFAULT_ADMIN_USERS_STATE,
  catalogs: DEFAULT_CATALOGS_STATE,
  catalogTypes: DEFAULT_CATALOG_TYPES_STATE,
  productContractGroups: DEFAULT_PRODUCT_CONTRACT_GROUPS_STATE,
  departments: DEFAULT_DEPARTMENTS_STATE,
  headerIsOpen: true
};

const adminReducer = (state, action) => {
  switch (action.type) {
    case setHeaderIsOpen.type:
      return {
        ...state,
        headerIsOpen: action.payload
      };
    default:
      return state;
  }
};

export default normalize.combineMiniReducers(
  {
    accountsReducer,
    adminReducer,
    adminUsersReducer,
    catalogsReducer,
    catalogTypesReducer,
    productContractGroupsReducer,
    departmentsReducer
  },
  DEFAULT_ADMIN_STATE
);
